export function getWidgetContentItemPropsFromValue(item) {
  return { value: item }
}
